import { useMemo } from 'react';
import useRetainerRequestQuestions from '../../../hooks/useRetainerRequestQuestions';
import useSupportedRetainerTypes from '../../../hooks/useSupportedRetainerTypes';
import useGetEnableRetainerRequest from './useGetEnableRetainerRequest';

// This hook is used to fetch all the data needed for the retainer request
// After fetched data, it will be dispatched and stored in the redux store

export const NEED_RETAINER_API_PATH = ['/patients'];
export const useFetchRetainerReqNeededData = (location) => {
    const isFetchRetainerRelatedData = useMemo(() => {
        if (location && location?.pathname && location?.pathname.length > 0) {
            const currentPath = location.pathname;
            return NEED_RETAINER_API_PATH.some((path) => currentPath.startsWith(path));
        }
        return false;
    }, [location]);

    useSupportedRetainerTypes(isFetchRetainerRelatedData);
    useRetainerRequestQuestions(isFetchRetainerRelatedData);
    useGetEnableRetainerRequest(isFetchRetainerRelatedData);
};
